import { graphql } from 'react-relay';

export const performanceByYearFragment = graphql`
  fragment PerformanceByYear_component on PerformanceByYear {
    performanceTitle: title
    lineItems {
      ...PerformanceByYearLineItem_component
    }
  }
`;
